module.exports = __webpack_public_path__ + "static/media/stepping_stones.4176ee7d.webp";